var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52006 2.63607H7.96941V0.111793C7.71936 0.0773953 6.85941 0 5.8579 0C3.76823 0 2.33675 1.3144 2.33675 3.73019V5.95349H0.0307617V8.77544H2.33675V15.876H5.16399V8.7761H7.3767L7.72796 5.95415H5.16333V4.01C5.16399 3.19438 5.38361 2.63607 6.52006 2.63607Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d774edf1cba897a8525d3cfbf8424dc7.svg";
export { ForwardRef as ReactComponent };